import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaseblinkMarkMono = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 216 216",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M72 0H216V216H72V144H0V72H72V0ZM72 72V144H144V72H72Z",
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd"
	})
});
export default SvgCaseblinkMarkMono;
